import React, { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom";
import EditLessonWithoutContent from "./EditLessonWithoutContent";
import EditLessonWithContent from "./EditLessonWithContent";
import emptyLessonIcon from '../../../assests/course/emptyLessonIcon.png'
import fullLessonIcon from '../../../assests/course/fullLessonIcon.png'
import libraryLessonIcon from '../../../assests/course/libraryLessonIcon.png'
import ChooseTypePopup from "../../UI/ChooseTypePopup";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { assessmentsApi, lessonsApi } from "../../../utils";
import { throwApiError } from "../../lms-shared/store/error-handling-actions";
import ToastMessage from "../../UI/ToastMessage";
import { SourceTypeTextEnum } from "../../../models/SourceTypeEnum";
import { LessonContentTypeEnumText } from "../../../models/LessonContentTypeEnum";
import { AttachmentTypeEnumText } from "../../lms-shared/models/AttachmentTypeEnum";
import { ActivityTypeEnumText } from "../../../models/ActivityTypeEnum";

const EditLesson = () => {

    const texts = useSelector(state => state.translate.texts);
    const { homeUrl } = useSelector(state => state.application);
    const [typeLesson, setTypeLesson] = useState();
    const [details, setDetails] = useState(null)
    const [popup, setPopup] = useState(null)
    const location = useLocation()
    const navigate = useNavigate();
    const { guid } = useParams();

    const dispatch = useDispatch();

    const lessonsList = [
        { name: 'fullLesson', type: 'full', icon: fullLessonIcon, description: 'fullLessonDescription' },
        { name: 'emptyLesson', type: 'empty', icon: emptyLessonIcon, description: 'emptyLessonDescription' },
        // { name: 'libraryLesson', type: 'library', icon: libraryLessonIcon, description: 'libraryDescription' }
    ]
    useEffect(() => {
        if (guid && location.state) {
            setDetails({
                lessonId: guid,
                courseName: location.state.courseName,
                tocName: location.state.tocName,
                studyGroupId: location.state.studyGroupId,
                isProfession: location.state.isProfession,
            })
        }
        else {
            if (location.state && location.state.studyGroupId) {
                setDetails({
                    toCParentId: location.state.toCParentId,
                    studyGroupId: location.state.studyGroupId,
                    courseName: location.state.courseName,
                    tocName: location.state.tocName,
                    isProfession: location.state.isProfession,
                    lessonId: location.state.lessonId,
                    prevToCId: location.state.prevToCId
                })
            }
            else {
                navigate('/courses')
            }
        }
    }, [])

    const closeOnClick = () => {
        setTypeLesson(null);
    }

    const selectOnClick = async (l) => {
        const lessonMoreDetails = JSON.parse(l?.contentData);
        const ideId = l.ide?.id || lessonMoreDetails?.Ide?.Id || 1;
        const lessonAddInput = {
            name: l.name,
            description: l.description,
            studyGroupId: details.studyGroupId,
            parentToCId: details.toCParentId,
            prevToCId: details.prevToCId,
            ideId,
            active: true,
            visible: false,
        }
        lessonsApi.lessonsAddPost({ lessonAddInput }, (error, resdata, response) => {
            setTypeLesson(null);
            if (error) {
                dispatch(throwApiError({ userMessage: texts.lessonsAddError, error: error, statusCode: response?.statusCode, message: "lessonsAddPost " + error.message, level: 2, component: "EditLesson", line: 81 }))
            }
            else {
                const lessonId = resdata;
                if (lessonMoreDetails?.FinalAssessment) {
                    const assessmentAddInput = {
                        lessonId: lessonId,
                        sourceType: SourceTypeTextEnum.IDE,
                        activityType: ActivityTypeEnumText.Final,
                        name: lessonMoreDetails.FinalAssessment?.Name,
                        description: lessonMoreDetails.FinalAssessment?.Description,
                        // contentData: JSON.stringify(lessonMoreDetails?.FinalAssessment?.ContentData)
                    }
                    assessmentsApi.assessmentsAddPost({ assessmentAddInput }, (error, resdata, response) => {
                        if (error) {
                            dispatch(throwApiError({ userMessage: texts.assessmentsAddError, error: error, statusCode: response?.statusCode, message: "assessmentsAddPost " + error.message, level: 2, component: "EditLesson", line: 91 }))
                        }
                        else {
                            // if(baseProjectId){
                            //     const assessmentAddBaseProjectInput = {
                            //         id: resdata,
                            //         baseProjectId: p.id
                            //     }
                            //     assessmentsApi.assessmentsAddBaseProjectPost({ assessmentAddBaseProjectInput }, (error, resdata, response) => {
                            //         setShowLibrary(false)
                            //         if (error) {
                            //             dispatch(throwApiError({ userMessage: texts.AssesmentAddBaseProjectError, error: error, statusCode: response?.statusCode, message: "assessmentsAddBaseProjectPost " + error.message, level: 2, component: "AddProject", line: 64 }))
                            //         }
                            //         else {
                            //         }
                            //     })
                            // }
                            if (lessonMoreDetails.FinalAssessment.ContentData.Attachments?.length) {
                                lessonMoreDetails.FinalAssessment.ContentData.Attachments.forEach(fileObj => {
                                    const url = l.url + '/' + lessonMoreDetails.FinalAssessment.BaseUrl + '/' + fileObj.FileSubUrl;
                                    convertUrlToFile(url, fileObj.Description, (file) => {
                                        let data = {
                                            id: resdata.id,
                                            attachmentType: AttachmentTypeEnumText.File,
                                            fileDescription: fileObj.Description,
                                            file
                                        }
                                        assessmentsApi.assessmentsAddFilePost(data, (error, resdata, response) => {
                                            if (error) {
                                                dispatch(throwApiError({ userMessage: "", error: error, statusCode: response?.statusCode, message: "assessmentsAddFilePost " + error.message, level: 1, component: "Attachments", line: 27 }))
                                            }
                                            else {
                                                console.log('resdata', resdata);
                                            }
                                        })
                                    })
                                })
                            }
                        }
                    })
                }
                let formData = {};
                // if (lessonMoreDetails.MaterialContentTypeId) {
                //     const url = l.url + '/' + lessonMoreDetails.MaterialUrl + '/meta.json?notCacheNumber=1675785436543';
                //     convertUrlToFile(url, 'file.zip', (file) => {
                //         formData = {
                // lessonContent: LessonContentTypeEnumText.Material,
                //             contentType: lessonMoreDetails.MaterialContentTypeId,
                //             id: lessonId,
                //             file
                //         }
                //         lessonsApi.lessonsAddFilePost(formData, (error, resdata, response) => {
                //             if (error) {
                //                 dispatch(throwApiError({ userMessage: texts.lessonsAddFileError, error: error, statusCode: response?.statusCode, message: "lessonsAddFilePost " + error.message, level: 2, component: "LessonContent", line: 49 }))
                //             } else {
                //                 console.log('resdata', resdata);
                //             }
                //         })
                //     })
                // }
                if (lessonMoreDetails.PlanContentTypeId) {
                    const url = l.url + '/' + lessonMoreDetails.PlanUrl;
                    const fileName = lessonMoreDetails.PlanUrl.split('/').pop()
                    convertUrlToFile(url, fileName, (file) => {
                        formData = {
                            lessonContent: LessonContentTypeEnumText.Plan,
                            contentType: lessonMoreDetails.PlanContentTypeId,
                            attachmentType: AttachmentTypeEnumText.File,
                            id: lessonId,
                            file
                        }
                        lessonsApi.lessonsAddFilePost(formData, (error, resdata, response) => {
                            if (error) {
                                dispatch(throwApiError({ userMessage: texts.lessonsAddFileError, error: error, statusCode: response?.statusCode, message: "lessonsAddFilePost " + error.message, level: 2, component: "LessonContent", line: 49 }))

                            } else {
                                console.log('resdata', resdata);
                            }
                        })
                    })
                }
                setPopup(<ToastMessage text={texts.LessonFromLibraryAddedSuccessfully} color="green" close={() => { setPopup(null); navigate(`${homeUrl}/courses/`) }} />)
            }
        })
    }

    const convertUrlToFile = async (url, fileName, callback) => {
        fetch(url)
            .then(res => res.blob())
            .then(blob => new File([blob], fileName))
            .then(file => callback(file))
            .catch(e => console.log('error in convertUrlToFile', e))
    }

    const renderLessonType = () => {
        switch (typeLesson) {
            case lessonsList[0].type: return <EditLessonWithContent studyGroupId={details.studyGroupId} courseName={details.courseName} tocName={details.tocName} toCParentId={details.toCParentId} isProfession={details.isProfession} prevToCId={details.prevToCId} />;
            case lessonsList[1].type: return <EditLessonWithoutContent {...details} />;
            // case lessonsList[2].type: return <ContentBankPopup type={ClassificationEnum.lesson} selectOnClick={selectOnClick} closeOnClick={closeOnClick} />;
            default: return '';
        }
    }

    return (
        <>
            {details && <>
                {
                    details.lessonId ?
                        <EditLessonWithContent {...details} idLesson={details.lessonId} ></EditLessonWithContent >
                        :
                        <>
                            {!typeLesson && <ChooseTypePopup setTypeLesson={setTypeLesson} lessonsList={lessonsList} title={texts.addLessonTitle} typeTitle={texts.addLessonTypeTitle} />}
                            {renderLessonType()}
                        </>
                }
                {popup}
            </>
            }
        </>
    )

}

export default EditLesson;